module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkAQAAAABYmaj5AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAd2KE6QAAAAHdElNRQfdCggPCBrTl6FQAAAASUlEQVQ4y2P4jwQ+MAww7wADDNgPPI8f6KYDDMz/BwMPyAAK/WEYDDwQgwHhzoHmARPO4OABnQWOtsHA44fmqcHAG0R5evCUdQBbSPTrFrOo8QAAACV0RVh0ZGF0ZTpjcmVhdGUAMjAxOC0wOC0xM1QxNToyNjo0MiswOTowMN960EEAAAAldEVYdGRhdGU6bW9kaWZ5ADIwMTMtMTAtMDhUMDY6MDg6MjYrMDk6MDDL5wzeAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/tag/36h11/tag36_11_00438_100x100.png
// module id = QmsE
// module chunks = 0